

<template>
  <div>
    <div>
      <vx-card>
        <div class="mt-5" v-if="dadosChamado">
          <h3 class="mb-6">Chamado {{dadosChamado.chamado.idChamado}}</h3>
          <div>
            <div class="vx-row">              
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <vs-list>
                  <vs-list-item icon="person" title="Nome">
                    {{dadosChamado.chamado.Chamado_Usuario.nome}}
                  </vs-list-item>
                  <vs-list-item icon="phone" title="Telefone">
                    {{dadosChamado.chamado.Chamado_Usuario.telefone}}
                  </vs-list-item>
                  <vs-list-item icon="mail" title="Email">
                    {{dadosChamado.chamado.Chamado_Usuario.email}}
                  </vs-list-item>
                </vs-list>
              </div>            
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <vs-list>
                  <vs-list-item icon="place" title="Área / Setor">
                    {{dadosChamado.chamado.Chamado_domArea.nomeArea}} / {{dadosChamado.chamado.Chamado_domSetor.nomeSetor}}
                  </vs-list-item>
                  <vs-list-item icon="apartment" title="Situação Atual">
                    {{dadosChamado.chamado.Chamado_domStatusChamado.nomeStatus}}
                  </vs-list-item>
                  <vs-list-item icon="date_range" title="Data do Chamado">
                    {{formataData(dadosChamado.chamado.createdAt)}}
                  </vs-list-item>
                </vs-list>
              </div>
            </div>   
            <div class="vx-row">         
              <div class="vx-col sm:w-1/1 w-full mb-2">
                <vs-list>
                  <vs-list-item icon="forum" title="Assunto">
                    {{dadosChamado.chamado.assunto}}
                  </vs-list-item>
                  <vs-list-item icon="forum" title="Mensagem">
                    {{dadosChamado.chamado.mensagem}}
                  </vs-list-item>
                  <vs-list-item icon="forum" title="Imagens" style="overflow: auto" v-if="dadosChamado.chamado.files.length > 0">
                    <div style="display: inline-flex" @click="openFile(dadosChamado.chamado.files)">
                      <img 
                        :src="file.arquivo" 
                        v-for="file in dadosChamado.chamado.files" 
                        :key="file.idArquivo"
                        width="50" height="50"
                      />
                    </div>
                  </vs-list-item>
                </vs-list>
              </div>
            </div>
            <h3 class="mb-6">{{dadosChamado.respostas.length > 0 ? dadosChamado.respostas.length == 1 ? dadosChamado.respostas.length + " Resposta" : dadosChamado.respostas.length + " Respostas" : "Sem Respostas"}} </h3>
            <div class="vx-row">
              <div class="vx-col sm:w-1/1 w-full mb-2">
              <vs-list v-for="item in dadosChamado.respostas" :key="item.idResposta">
                <vs-list-header icon-pack="feather" icon="icon-users" :title="item.autor"></vs-list-header>
                <vs-list-item icon="reply" title="Resposta  " 
                v-bind:subtitle="formataData(item.createdAt)"
                style="overflow: auto">
                {{item.resposta}}
                </vs-list-item>
                <vs-list-item icon="forum" title="Imagens" style="overflow: auto" v-if="item.files.length > 0">
                  <div style="display: inline-flex" @click="openFile(item.files)">
                    <img 
                      :src="file.arquivo" 
                      v-for="file in item.files" 
                      :key="file.idArquivo"
                      width="50" height="50"
                    />
                  </div>
                </vs-list-item>
              </vs-list>
                <!-- <vs-list>
                  <vs-list-item v-for="item in dadosChamado.respostas" :key="item.idResposta"
                  icon="reply" v-bind:title="item.autor" 
                  v-bind:subtitle="formataData(item.createdAt)"
                  style="overflow: auto">
                  {{item.resposta}}
                  </vs-list-item>
                </vs-list> -->
                <!-- <p>{{ item.OuvidoriaResposta_Usuarios.nome }} respondeu em {{ formataData(item.createdAt) }} </p>
                <p>{{item.resposta}}</p> -->
              </div>
            </div>
            <form role="form" @submit.stop.prevent autocomplete="off">
              <div class="vx-row">
                <div class="vx-col sm:w-1/1 w-full mb-2">
                  <vs-textarea 
                    label="Inserir Nova Resposta" 
                    v-model="form.resposta"
                    name="Resposta"
                    v-validate="{ required: true }"      
                    :state="validateState('Resposta')"
                    :danger="validateClass('Resposta')" 
                  />
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col w-full text-right">
                  <div class="vx-col w-full mt-5">
                    <input id="fileUpload" type="file" hidden v-on:change="selecionaArquivo" />
                    <vs-button
                      color="warning"
                      type="border button"
                      class="vs-lg-12"
                      @click="chooseFiles()"
                    >
                      Adicionar Imagens
                      <feather-icon icon="UploadIcon" class="ml-2" />
                      <Br />
                      <div v-if="files.length > 0">
                        <vs-chip v-for="item in files" :key="item[0].name" class="mt-3">
                          <vs-avatar icon-pack="feather" icon="icon-file" />
                          <span>{{ item[0].name }}</span>
                        </vs-chip>
                      </div>
                    </vs-button>
                  </div>
                  <!-- <vs-button
                    color="success"
                    @click="responderChamado"
                    class="mt-2 mb-2"
                  >Nova Resposta</vs-button> -->
                </div>
              </div>
            </form>
          </div>
        </div>
      </vx-card>
      <div class="vx-row" v-if="dadosChamado">
        <div class="vx-col w-full text-right" v-if="dadosChamado.chamado.Chamado_domStatusChamado.nomeStatus != 'Finalizado'">
          <vs-button
            color="danger"
            @click="confirmFinaliza"
            type="gradient"
            class="mt-2 mb-2"
          >Responder e Finalizar Chamado</vs-button>
          <vs-button style="margin-left: 1%"
            color="success"
            @click="responderChamado"
            type="gradient"
            class="mt-2 mb-2"
          >Nova Resposta</vs-button>
        </div>
      </div>
      <!-- <div class="vx-row mt-3">
        <div v-if="precisaAlterarProduto==false" class="vx-col w-full text-right">
          <form role="form" @submit.stop.prevent="onSubmit">
            <BotaoSubmit variant="success" :edit="true" :aguarde="aguardeCadastro"></BotaoSubmit>
          </form>
        </div>
        <div v-else class="vx-col w-full text-right">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click="passo=3"
          >Buscar e Atualizar Produtos</vs-button>
        </div>
      </div> -->
    </div>
    <vs-popup
      class="holamundo"
      :title="'Detalhes Arquivo'"
      :active.sync="popupFile"
      @close="closeFile"
    >
      <vs-list v-if="popupFile == true">
        <div class="carousel-example">
          <swiper :dir="$vs.rtl ? 'rtl' : 'ltr'" :key="$vs.rtl">
            <swiper-slide v-for="file in popupFiles" :key="file.idArquivo">
              <img class="responsive" :src="file.arquivo" alt="banner">
            </swiper-slide>
          </swiper>
        </div>
      </vs-list>
    </vs-popup>

    <vs-popup
      class="holamundo"
      :title="'Finalizar Chamado'"
      :active.sync="popupFinaliza"
      @close="closeFinaliza"
    >
      <vs-list>
        <vs-list-header title="Deseja Finalizar o Chamado?" color="gray"></vs-list-header>
        <vs-list-item>
          <vs-button @click.stop.prevent="closeFinaliza()" 
          color="danger" 
          type="border">Cancelar</vs-button>
          <vs-button style="margin-left: 10px" 
          @click="finalizaChamado()" 
          color="success" 
          type="filled">Confirmar</vs-button>
        </vs-list-item>
      </vs-list>
    </vs-popup>

  </div>
</template>

<script>
import service from "./../../services";
import locale from "./../../locale";
import Datepicker from "vuejs-datepicker";
import { Money } from "v-money";
import moment from "moment";
import BotaoSubmit from "../../components/BotaoSubmit";
import jwt from "jsonwebtoken";
import 'swiper/dist/css/swiper.min.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  components: {
    Datepicker,
    Money,
    BotaoSubmit,
    swiper, 
    swiperSlide
  },
  data() {
    return {
      aguardeCadastro: false,
      dadosChamado: null,
      precisaAlterarProduto: false,
      regionais: [],
      consultores: [],
      status: [],
      grupos: [],
      listaCores: [],
      listaCombustiveis: [],
      fotos: [],
      form: {
        idChamado: this.$route.params.idChamado,
        autor: null,
        resposta: "",        
        pathFiles: []
      },
      passo: 0,
      
      popupFile: false,
      popupFiles: [],
      
      popupFinaliza: false,

      file: new FormData(),
      files: [],
      paths: [],
    };
  },
  methods: {
    responderChamado() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.aguardeCadastro = true;
          var user = this.buscaUsuario();
          if(!user) {
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text: `Problemas ao Buscar o Usuário`,
              color: "danger"
            });
            return
          }
          this.form.autor = user
          this.$vs.loading();
          service
            .post("Chamado", "InserirResposta", this.form)
            .then(res => {
              this.aguardeCadastro = false;
              this.$vs.loading.close();
              this.$vs.notify({
                position: "top-center",
                title: "Obrigado",
                text: `Operação Realizada com sucesso`,
                color: "success"
              });
              this.$emit("concluido");
              this.form.resposta = "";
              this.form.pathFiles = [];
              this.files = [];
              this.buscaDados();
            })
            .catch(error => {
              this.aguardeCadastro = false;
              this.$vs.loading.close();
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: error,
                color: "danger"
              });
            });
        }
      });
    },

    buscaDados() {
      this.$vs.loading();
      var objSend = {};
      objSend.idChamado = this.$route.params.idChamado;
      objSend.qtdPorPagina = this.itemsPerPage;
      objSend.idEmpresa = this.idEmpresa;
      service
        .post("Chamado", "listarRespostasChamado", objSend)
        .then(res => {
          if (res.data.chamado) {
            this.dadosChamado = res.data;
            this.dadosChamado.chamado.files = res.data.files.filter((file) => { return !file.idResposta });
            this.dadosChamado.respostas.forEach(element => {
              element.files = res.data.files.filter((file) => { return file.idResposta == element.idResposta });
            });
            this.$vs.loading.close();
          } else {
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text:
                "Você não tem acesso a visualização deste Chamado",
              color: "danger"
            });
            this.$vs.loading.close();
          }
        })
        .catch(e => {
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: e,
            color: "danger"
          });
          this.$vs.loading.close();
        });
    },
    formataData(data) {
      return moment(data).format("DD/MM/YYYY HH:mm");
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    buscaUsuario() {
      const token = localStorage.getItem("user-token");
      if (token) {
        const decoded = jwt.decode(token);
        return decoded.email
      }else{
        return null
      }
    },

    
    openFile (files) {
      this.popupFiles = files;
      this.popupFile = true;
    },
    closeFile () {      
      this.popupFile = false;
    },    
    selecionaArquivo(event) {
      var files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      this.file.set("file", event.target.files[0], event.target.files[0].name);
      this.files.push(files);
      this.paths.push(this.file);
      this.$vs.loading();
      var that = this;
      service
      .upload("Upload", "chamado/" + this.dadosChamado.chamado.idEmpresa, this.file)
      .then(response => {
        that.form.pathFiles.push(response);
        that.$vs.loading.close();
      })
      .catch(function(error) {
        that.$vs.notify({
          position: "top-center",
          title: "Atenção",
          text: error,
          color: "danger"
        });
        that.$vs.loading.close();
      });
    },    
    chooseFiles() {
      document.getElementById("fileUpload").click();
    },
        
    confirmFinaliza(chamado) {
      this.popupFinaliza = true;
    },      
    closeFinaliza() {
      this.popupFinaliza = false;
    },  
    finalizaChamado(){
      console.log("filtro", this.form);
      this.$validator.validateAll().then((result) => {
        if (result) {
          var user = this.buscaUsuario();
          if(!user) {
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text: `Problemas ao Buscar o Usuário`,
              color: "danger"
            });
            return
          }
          this.form.autor = user;
          service
            .post("Chamado", "responderFinalizarChamado", this.form)
            .then(res => {
              this.closeFinaliza();
              this.$vs.loading.close();
              this.$vs.notify({
                position: "top-center",
                title: "Obrigado",
                text: 'Seu Chamado foi Finalizado!',
                color: "success"
              });
              this.form.resposta = "";
              this.form.pathFiles = [];
              this.buscaDados();
            });
        }
      });
    },
  },
  mounted() {
    this.$validator.localize("ptBr", locale);
    localStorage.removeItem("formFiltro");
    this.buscaDados();
  }
};
</script>
<style >
.vdp-datepicker input {
  width: 100%;
}
</style>

